import { useDispatch, useSelector } from 'react-redux';
import { itemDeselected } from 'Vendor/Store/studio';
import { AppDispatch } from 'Vendor/Store/store';
import { selectActivePageId, selectSelectedItemIds } from 'Vendor/Store/studio/selectors';
import { clearActiveTool } from 'Vendor/Store/studio/activeToolSlice';

interface HeaderProps {
    title: string;
    setShow: (show: boolean) => void;
    forceSave: () => Promise<void>;
}

const Header = ({ title, setShow, forceSave }: HeaderProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const selectedItem = useSelector(selectSelectedItemIds);
    const activePageId = useSelector(selectActivePageId);

    const handleBackClick = async () => {
        dispatch(clearActiveTool());

        if (selectedItem.length > 0) {
            dispatch(itemDeselected({ pageId: activePageId }));
        } else {
            try {
                await forceSave();
                setShow(false);
            } catch {}
        }
    };

    return (
        <div
            onClick={handleBackClick}
            className="d-flex justify-content-start align-items-center text-decoration-none space-x-2"
            style={{ cursor: 'pointer' }}
        >
            <i className="fa-solid fa-arrow-left h3 text-white"></i>
            <h3 className="text-white">{title}</h3>
        </div>
    );
};

export default Header;
